import { Link } from 'react-router-dom';
import { Card } from '@dma/ui';
import type { MineralDto } from '../application/dto/MineralDto';
import './MineralCard.css';

const CATEGORY_LABEL: Record<MineralDto['category'], string> = {
  calcite: 'کلسیت',
  aragonite: 'آراگونیت',
  kaolin: 'کائولن',
  other: 'سایر'
};

export interface MineralCardProps {
  mineral: MineralDto;
}

export function MineralCard({ mineral }: MineralCardProps) {
  return (
    <Link to={`/minerals/${mineral.slug}`} className="dma-mineral-card__link">
      <Card className="dma-mineral-card">
        <img
          className="dma-mineral-card__image"
          src={mineral.images[0]}
          alt={mineral.name}
          loading="lazy"
        />
        <div className="dma-mineral-card__body">
          <span className="dma-mineral-card__category">{CATEGORY_LABEL[mineral.category]}</span>
          <h3 className="dma-mineral-card__title">{mineral.name}</h3>
        </div>
      </Card>
    </Link>
  );
}
